/// <amd-module name="Test/TestSummary/Components/TestAnalyticsLink" />
import { ITestAnalyticsLinkData, ITestReportContext } from "Test/Analytics/Common/Types";
import { FailedTestsSourceService } from "Test/FailedTestsMetricView/Services/FailedTestsSourceService";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { ViewContext } from "Test/common-util/Common";
import * as TCMContracts from "Test/common-util/Contracts/Test";

export async function getTestAnalyticsLinkData(context: IVssComponentContext, pipelineContext: ViewContext, definitionId: number): Promise<ITestAnalyticsLinkData> {
    let contributionService: IVssContributionService = context.pageContext.getService<IVssContributionService>("IVssContributionService");
    await contributionService.getContributionAsync("ms.vss-test-analytics-web.failed-tests-metric-view");

    let failedTestsSource = context.pageContext.getService<FailedTestsSourceService>("FailedTestsSourceService");
    if (failedTestsSource) {
        failedTestsSource.initialize("FailedTestsSourceService", context.pageContext);
    }

    let testReportContext: ITestReportContext;
    if (pipelineContext === ViewContext.Build) {
        testReportContext = { contextType: TCMContracts.TestResultsContextType.Build, definitionId: definitionId };
    }
    else {
        testReportContext = { contextType: TCMContracts.TestResultsContextType.Release, definitionId: definitionId }
    }

    return failedTestsSource.getTestAnalyticsLinkData(testReportContext);
}

